import { createContext, type ReactNode, type FC } from 'react';

type CartServerVarsContext = {
    isMobile: boolean;
};

export const CartServerVarsContext = createContext<CartServerVarsContext>({
    isMobile: false,
});

type Props = {
    children: ReactNode;
    isMobile: boolean;
};

export const CartServerVarsContextProvider: FC<Props> = ({ children, isMobile }) => (
    <CartServerVarsContext.Provider
        value={{
            isMobile,
        }}
    >
        {children}
    </CartServerVarsContext.Provider>
);
